import _ from 'underscore';

const FormSubmit = {
  onSubmit(e) {
    e.preventDefault();
    this._handleSubmit();
  },

  _onProxySubmit(section, e) {
    e.preventDefault();
    this._handleSubmit(section);
  },

  _handleSubmit(section) {
    if (!this.state.loading && this.isValid(section)) {
      this.formSubmitted(this._submitParams(section));
    }
  },

  _submitParams(section) {
    let fields;
    let additionalParams;

    if (typeof this._additionalSubmitParams === 'function') {
      additionalParams = this._additionalSubmitParams();
    }

    if (section === undefined) {
      fields = this.state.fields.toJS();
    } else {
      fields = this._sectionFields(section);
    }

    return _.extend(fields, additionalParams);
  },
};

export default FormSubmit;
